import {postData} from "../api/componentAPIs"
export function fetchConfig() {
  //Change the query string to avoid JSON caching
  return fetch("../externalConfig/config.json?release=1.3.3").then((response) =>
    response.json()
  );
}

export function SavePreferences({ name, config, userColumnPref, userId }) {
  if (!userColumnPref) {
    userColumnPref = {};
  }
  userColumnPref[name] = config;
  postData("SetUserPreferences", {
    userId: userId,
    columnOrderPref: JSON.stringify(userColumnPref),
  }).then(
    (response) => {
      if (response && response.status === 200)
        console.log(`User ${userId} preferences saved`);
    },
    (error) => {
      console.log("Error while saving preferences ", error);
    }
  );
  return userColumnPref;
}

// Update to recevive data from tenant JSON file instead of functions
export const getRouteNameEditorParams =(code) => {
  switch (code) {
    case 2: // currently for SEFL
      return {
        mask: [/[^_\s]/, /[^_\s]/, /[^_\s]/],
        placeholder: "Route Format: ***",
        format: /^\w{3}$/ /* match=xxx where x∈{num, char, underscore} */,
        capitalize: true,
      };
    case 3: // currently for Yellow
      return {
        mask: [/[^_\s]/, /[^_\s]/, /[^_\s]/, /[^_\s]/, /[^_\s]/],
        placeholder: "Route Format: *****",
        format: /^\w{5}$/ /* match=xxxxx where x∈{num, char, underscore} */,
        capitalize: true,
      };
    case 4: // currently for FFE
      return {
        mask: [/[^_\s]/, /[^_\s]/, /[^_\s]/, /[^_\s]/, /[^_\s]/, /[^_\s]/],
        placeholder: "Route Format: ******",
        format: /^\w{6}$/ /* match=xxxxxx where x∈{num, char, underscore} */,
        capitalize: true,
      };
    case 1:
    default:
      return {
        mask: [/[^_\s]/, /[^_\s]/, /[^_\s]/, "_", /\d/],
        placeholder: "Route Format: ***_(0-9)",
        format: /^[^_\s]{3}_\d$/,
        capitalize: true,
      };
  }
}

export const getTerminalAccessLabel = (code) => {
  switch (code) {
    case 2:
      return {
        menuLabel: "Svc Center",
        moduleTitle: "Service Center Access",
        shortName:"Svc Center",
        fullName:"Service Center",
        suffix:"Svc"
      };
    case 1:
    default:
     return {
       menuLabel: "Terminal Access",
       moduleTitle: "Terminal Access",
       shortName: "Terminal",
       fullName: "Terminal",
       suffix:"Term"
     };
  }
}